import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'

Vue.use(Vuex);

let state = {
    isBlogOfLinks: window.location.host === 'andrew.ooo' || window.location.host.indexOf('localhost') > -1,
    user: null,
    loggedIn: false,
    mode: 'public'
};

firebase.auth().onAuthStateChanged(function(user) {
    console.log('onAuthStateChanged');
    state.user = user;
    state.loggedIn = (user);

});

export const store = new Vuex.Store({
    state: state,
    actions: {
      changeMode ({ commit }, { mode }) {
        commit('changeMode', { mode: mode });
      },
    },
    getters: {
        getUser: state => {
            return state.user || {}
        },
        loggedIn: state => {
            return state.loggedIn
        }
    },
    mutations: {
      changeMode (state, data) {
          state.mode = data.mode;
      },
    }
});



// WEBPACK FOOTER //
// ./src/store/store.js